import { basicPath } from '../basicPath';

// GET: Fetch all dates for a specific book
export const fetchBookStudentDatesByBook = (params) => async (dispatch) => {
    const { bookId } = params;
    const path = `/rp/book-student-dates/book/${bookId}`;
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

// GET: Fetch all dates for a student-book combination
export const fetchBookStudentDatesByStudentBook = (params) => async (dispatch) => {
    const { studentId, bookId } = params;
    const path = `/rp/book-student-dates/student/${studentId}/book/${bookId}`;
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

// GET: Fetch all dates for a book list
export const fetchBookStudentDatesByBookList = (params) => async (dispatch) => {
    const { bookListId } = params;
    const path = `/rp/book-student-dates/book-list/${bookListId}`;
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

// POST: Create or update a date entry
export const saveBookStudentDate = (params) => async (dispatch) => {
    const path = '/rp/book-student-dates';
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

// PUT: Update a date entry by ID
export const updateBookStudentDate = (params) => async (dispatch) => {
    const { id } = params;
    const path = `/rp/book-student-dates/${id}`;
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

// DELETE: Delete a date entry
export const deleteBookStudentDate = (params) => async (dispatch) => {
    const { id } = params;
    const path = `/rp/book-student-dates/${id}`;
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}

